import api from "@/services/axiosInstance";

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL;
const content = "purchase";
const version = "v1";

// suppliers
export const fetchV1Suppliers = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/suppliers/?page_size=${pageSize}&page=${page}`;

  console.log("suppliers API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching suppliers:", error);
    throw error;
  }
};

export const createV1Supplier = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/suppliers/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating supplier at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to create an author" };
    }

    throw error;
  }
};

// purchase
export const fetchV1Puchases = async (
  page = 1,
  pageSize = 5,
  supplier = null
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/?page_size=${pageSize}&page=${page}`;

  if (supplier) {
    URL += `&supplier=${supplier}`;
  }

  console.log("Purchases API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching purchases:", error);
    throw error;
  }
};

export const fetchV1Purchase = async (purchaseCode = null) => {
  const URL = `${API_BASE_URL}/${content}/${version}/${purchaseCode}/`;
  console.log("Purchase Details API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase:", error);
    throw error;
  }
};

export const createV1Purchase = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating Purchase at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied!" };
    }

    throw error;
  }
};
